import { useTranslation } from 'react-i18next';

const useGetTabOptions = () => {
  const { t } = useTranslation('host-presence', 'host-content');

  return [
    { type: 'presence', label: t('host-presence:page.title') },
    { type: 'content', label: t('host-content:page.title') },
  ];
};

export default useGetTabOptions;
